import { motion, AnimatePresence } from "framer-motion";

export const NAV_LINKS = [
  { href: "#philosophy", label: "Philosophy", testid: "philosophy" },
  { href: "#services", label: "Services", testid: "services" },
  { href: "#calculator", label: "Calculator", testid: "calculator" },
  { href: "#about", label: "About", testid: "about" },
  { href: "#book", label: "Book a Call", testid: "book" },
];

export const MobileMenu = ({ open, onClose }) => (
  <AnimatePresence>
    {open && (
      <motion.nav
        initial={{ height: 0, opacity: 0 }}
        animate={{ height: "auto", opacity: 1 }}
        exit={{ height: 0, opacity: 0 }}
        transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
        data-testid="nav-mobile-menu"
        className="md:hidden overflow-hidden bg-[#FBF7F2] border-t border-black/[0.08]"
      >
        <div className="px-6 py-8 flex flex-col gap-6">
          {NAV_LINKS.map((l, i) => (
            <motion.a
              key={l.href}
              href={l.href}
              onClick={onClose}
              initial={{ opacity: 0, x: -12 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.08 + i * 0.05, duration: 0.35 }}
              data-testid={`nav-mobile-${l.testid}-link`}
              className="font-display text-2xl font-medium text-[#493E38]"
            >
              {l.label}
            </motion.a>
          ))}
          <motion.a
            href="#contact"
            onClick={onClose}
            initial={{ opacity: 0, x: -12 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.28, duration: 0.35 }}
            data-testid="nav-mobile-enquire-button"
            className="mt-2 inline-flex self-start px-8 py-3.5 rounded-full bg-[#DBB89C] text-white text-xs font-semibold tracking-[0.25em] uppercase"
          >
            Enquire
          </motion.a>
        </div>
      </motion.nav>
    )}
  </AnimatePresence>
);
